import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import WebFontLoader from 'webfontloader';

import './index.css';

WebFontLoader.load({
	google: {
		families: ['Roboto:300,400,500,700', 'Nunito:500,700', 'Material Icons'],
	},
});


ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js